<template>
  <div id="layout">
    <div id="viewer-container" />
    <header-product
      v-if="isProductLoaded"
      class="upper-watermark"
    />
    <glance-options-item
      v-if="isGlancedOptionsItemAvailable"
      class="upper-watermark"
    />
    <gamepad
      v-if="isProductLoaded"
      class="upper-watermark"
      @arClick="$emit('arClick')"
      @resetClick="$emit('resetClick')"
      @dimensionsClick="$emit('dimensionsClick')"
      @screenshotClick="$emit('screenshotClick')"
      @projectClick="$emit('projectClick')"
    />
  </div>
</template>

<script>
  import HeaderProduct from '../headers/HeaderProduct.vue'
  import GlanceOptionsItem from '../glances/GlanceOptionsItem.vue'
  import Gamepad from '../gamepad/Gamepad.vue'
  import { mapGetters } from 'vuex'
  import helpers from '../../js/helpers.js'
  import parameters from '../../js/parameters.js'

  export default {
    name: 'Viewer',

    components: {
      HeaderProduct,
      GlanceOptionsItem,
      Gamepad,
    },

    data () {
      return {
        isViewerLoaded: false,
      }
    },

    computed: {
      ...mapGetters(['getInspiViewerSrc', 'getInspiViewerUser', 'getInspiViewerToken', 'isProductLoaded', 'isGlancedOptionsItem']),
      isGlancedOptionsItemAvailable () {
        return helpers.isDesktop() && this.$vuetify.breakpoint.smAndUp && this.isGlancedOptionsItem
      },
    },

    mounted () {
      this.loadViewer()
    },

    methods: {
      loadViewer () {
        if (this.isViewerLoaded) return
        this.isViewerLoaded = true

        const viewer = document.createElement('inspi-viewer')
        viewer.id = 'inspi-viewer'
        parameters.apply(viewer)

        const container = document.querySelector('#viewer-container')
        container.appendChild(viewer)

        const script = document.createElement('script')
        script.setAttribute('src', this.getInspiViewerSrc)
        script.setAttribute('user', this.getInspiViewerUser)
        script.setAttribute('token', this.getInspiViewerToken)
        document.head.appendChild(script)
      },
    },
  }
</script>

<style scoped>
#layout {
  position: relative;
  width: 100%;
  height: 100%;
}

#viewer-container {
  width: 100%;
  height: 100%;
}

.upper-watermark {
  z-index: 100;
}
</style>
